document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".tabs").forEach((wrap) => {
    const tabList = wrap.querySelector(".section-tabs[role='tablist']");
    const tabs = tabList ? Array.from(tabList.querySelectorAll("[role='tab']")) : [];
    const panelsWrap = wrap.querySelector(".section-tabs-data");

    if (!tabs.length || !panelsWrap) return;

    function getPanelForTab(tab) {
      const panelId = tab.getAttribute("aria-controls");
      if (!panelId) return null;
      return panelsWrap.querySelector("#" + CSS.escape(panelId));
    }

    function updateViewAll(panel) {
      if (!panel) return;
      const section = wrap.closest('.carousel-products');
      if (!section) return;

      const btn = section.querySelector('.sec-head .btn');
      const text = btn?.querySelector('.text');
      if (!btn) return;

      const url = panel.getAttribute('data-collection-url');
      const title = panel.getAttribute('data-title');

      if (url) btn.setAttribute('href', url);
      if (text) text.textContent = title ? title : 'View All';
    }

    function setActiveTab(activeTab, moveFocus = true) {
      let activePanel = null;

      tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
        tab.setAttribute("tabindex", isActive ? "0" : "-1");

        const panel = getPanelForTab(tab);
        if (panel) {
          panel.hidden = !isActive;
          if (isActive) activePanel = panel;
        }
      });

      // Always update View All if panel exists
      if (!activePanel && tabs.length === 1) {
        // fallback: single panel
        activePanel = panelsWrap.querySelector(".tab-data");
        if (activePanel) activePanel.hidden = false;
      }

      updateViewAll(activePanel);

      if (moveFocus && activeTab) activeTab.focus();
    }

    function getActiveIndex() {
      const idx = tabs.findIndex((t) => t.getAttribute("aria-selected") === "true");
      return idx >= 0 ? idx : 0;
    }

    // Click activates tab
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => setActiveTab(tab, false));
    });

    // Keyboard navigation
    if (tabList) {
      tabList.addEventListener("keydown", (e) => {
        const key = e.key;
        const currentIndex = getActiveIndex();
        let nextIndex = null;

        if (key === "ArrowRight") nextIndex = currentIndex + 1;
        if (key === "ArrowLeft") nextIndex = currentIndex - 1;
        if (key === "Home") nextIndex = 0;
        if (key === "End") nextIndex = tabs.length - 1;

        if (nextIndex !== null) {
          e.preventDefault();
          if (nextIndex < 0) nextIndex = tabs.length - 1;
          if (nextIndex >= tabs.length) nextIndex = 0;
          setActiveTab(tabs[nextIndex], true);
          return;
        }

        if (key === "Enter" || key === " ") {
          e.preventDefault();
          setActiveTab(tabs[currentIndex], false);
        }
      });
    }

    // Init on load — always updates View All
    const initial = tabs.find((t) => t.getAttribute("aria-selected") === "true") || tabs[0];
    setActiveTab(initial, false);

    // Extra fallback for single tab without proper aria-controls
    if (tabs.length === 1) {
      const singlePanel = getPanelForTab(tabs[0]) || panelsWrap.querySelector(".tab-data");
      updateViewAll(singlePanel);
    }
  });
});